import { plural } from '../format.ts';

/** Оболонка (layout.md, розд. 1): верхня панель, навігація, меню користувача, глобальні банери. */
export const shell = {
  logoHome: 'Clientline — на головну',
  /** Посилання переходу між областями (WCAG 2.4.1): перший `Tab`, до верхньої панелі. */
  skipToContent: 'До вмісту',
  skipToNav: 'До навігації',
  skipToAside: 'До бічної панелі',
  search: 'Пошук: ім’я, телефон, email…',
  searchSoon: 'Пошук і швидке створення з’являться в наступних тікетах',
  quickCreate: 'Швидко створити',
  undoLast: 'Скасувати останню дію',
  /** Кошик людини (DAT-05): пункт меню користувача й команда палітри. */
  trash: 'Кошик',
  /** Черга можливих дублів (DAT-07): пункт меню користувача й команда палітри, лише з правом злиття. */
  duplicates: 'Дублі',
  notifications: 'Сповіщення',
  /** Команда `G` `N` (NTF-13): у шпаргалці й палітрі ще до живої частини дзвіночка (`Bell.tsx`). */
  notificationsKey: 'Центр сповіщень',

  navLabel: 'Розділи',
  navHome: 'Головна',
  navMailUnread: (n: number) =>
    plural(n, { one: 'непрочитаний лист', few: 'непрочитані листи', many: 'непрочитаних листів' }),
  /** Розділ «Адміністрування» (ADM-801): заголовок, вкладка, крихти. */
  navAdmin: 'Адміністрування',
  /** Підпис пункту в рейці: ≤ 12 символів, перенос лише зі знаком (layout.md, розд. 1, «Підпис»). */
  navAdminShort: 'Адмінка',
  /** Єдина сторінка адмінки в людини, що веде довідники: пункт рейки (≤ 12 символів) і команда палітри. */
  navReferences: 'Довідники',
  /** Перехід палітри до «Моїх задач» (E8a-W2): пункт меню — наповнення компанії. */
  navMyTasks: 'Мої задачі',
  /** Той самий підпис у рейці: м'який перенос (U+00AD), бо не в усіх рушіях є словник переносів для uk. */
  navReferencesRail: 'Довід\u00ADники',
  /** Пункт навігації з розділами понад перші сім (UX-02). */
  navMore: 'Ще',
  navMoreLabel: 'Інші розділи',
  navCollapse: 'Згорнути навігацію',
  navExpand: 'Розгорнути навігацію',
  noSectionsTitle: 'Немає доступних розділів',
  noSectionsText: 'Зверніться до адміністратора Clientline.',

  /** Меню довідки «?» (UX-39): клавіші, звернення, регламенти компанії, версія збірки. */
  help: 'Довідка',
  /** Модуль пунктів меню «?» не прийшов: меню закрито. */
  helpFailed: 'Не вдалося відкрити довідку. Спробуйте ще раз',

  userMenu: 'Меню користувача',
  menuTheme: 'Тема',
  themeSystem: 'Як у системі',
  themeLight: 'Світла',
  themeDark: 'Темна',
  menuDensity: 'Щільність',
  densityComfortable: 'Комфортно',
  densityCompact: 'Компактно',
  menuLite: 'Легкий режим',
  menuSingleKeys: 'Однолітерні гарячі клавіші',
  /** Вихід (user-cabinet.md, розд. 10.1): сесія закривається в усіх вкладках цього браузера. */
  signOut: 'Вийти',
  signOutFailed: 'Не вдалося вийти: немає відповіді сервера. Спробуйте ще раз.',
  /** Чанк діалогу «вийти без збереження?» не доїхав (стара вкладка після релізу, обрив). */
  signOutDialogFailed:
    'Не вдалося відкрити підтвердження виходу. Збережіть зміни, оновіть сторінку й спробуйте ще раз.',

  offline: 'Немає зв’язку. Зміни не зберігаються — введене не загубиться.',
  /** Повторний вхід поверх сторінки (UX-30): назва вкладки й заголовок шару. */
  reloginTitle: 'Сесія завершилась',
  /** Нова версія застосунку (UX-31). */
  versionAvailable: 'Доступна нова версія Clientline.',
  versionUpdate: 'Оновити',
  versionUpdating: 'Оновлюємо…',
  versionLater: 'Пізніше',
  /** Підказка зчитувачу біля зовнішнього посилання ↗ — поле `url` (#1271); у банера браузера — своя. */
  linkNewTab: '(відкриється в новій вкладці)',
  /** Текст зовнішнього посилання поля `url` без підпису `linkLabel` (#1271): «Відкрити ↗ · <хост>». */
  linkOpen: 'Відкрити',
} as const;
